/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Birthday from './Birthday/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import Greeting from './Greeting/index'
import LastName from './LastName/index'
import MiddleName from './MiddleName/index'
import React from 'react'
import Ssn from './Ssn/index'
import Title from './Title/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/Details"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Details.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1gssM9': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={dtColorsNeutral800}
 marginBottom={dtSpaceXs}
 marginTop={dtSpaceXs}
 marginLeft={dtSpaceXs}
 text="Main Details"
/>
</div>
<div
  data-testid="Details.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Details.Vertical"
  data-view-path={viewPath}
 style={{'--blc-2-Z1gssM9': dtColorsNeutral400,'--pl-3-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-5-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<MiddleName
  viewPath={`${viewPath}/MiddleName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
</div>
<div
  data-testid="Details.Vertical:1"
  data-view-path={viewPath}
 style={{'--blc-2-Z1gssM9': dtColorsNeutral400,'--pl-3-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-5-Z1gssM9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<Greeting
  viewPath={`${viewPath}/Greeting`}
/>
<Birthday
  viewPath={`${viewPath}/Birthday`}
/>
<Ssn
  viewPath={`${viewPath}/Ssn`}
/>
</div>
</div>
{children}
</React.Fragment>)
}